export default class StoreBookingOnLanding {
  init() {
    const $storeLocatorContainer = $('.store-locator-container');
    const serviceToBook = $storeLocatorContainer.data('service-to-book');
    const bookingStore = $storeLocatorContainer.data('booking-store');

    if (serviceToBook && bookingStore) {
      // If both service and store are set, trigger the booking modal for the service at the store
      if ($('.asyncBooking.' + serviceToBook + '.' + bookingStore).length > 0) {
        $('.stores-list')
          .find($('.asyncBooking.' + serviceToBook + '.' + bookingStore))
          .trigger('click');
      }
    } else if (serviceToBook || bookingStore) {
      // If only one of the two is set, trigger the booking modal from the hidden .service-book-landing-hidden button
      const $serviceBookHiddenButton = $('.service-book-landing-hidden');
      // Configure the hidden button as a modal opener for #booking-modal
      $serviceBookHiddenButton.attr('data-toggle', 'modal');
      $serviceBookHiddenButton.attr('data-target', '#booking-modal');

      let bookingUrl = $serviceBookHiddenButton.attr('data-bookingurl');

      if (bookingStore) {
        bookingUrl = bookingUrl.concat('?store=' + bookingStore);
      } else if (serviceToBook) {
        bookingUrl = bookingUrl.concat('?service=' + serviceToBook);
      }
      $serviceBookHiddenButton.attr('data-bookingurl', bookingUrl);
      $serviceBookHiddenButton.trigger('click');
    }
  }
}
